enum COOKIES {
  browserCookieId = 'BrowserCookieId',
  correspondingEventId = 'vdp-corresponding-event-id',
  dataDogSampling = '_dd_s',
  nativeAppVersion = 'X-CVNA-AppVersion',
  nativeHomeInView = 'nativeHomeInView',
  preferredTrade = 'merch-preferred-trade',
  searchRequestId = 'searchRequestId',
  sebastianReadiness = 'X-CVNA-SebastianReadiness',
  tradeInApplied = 'merch-tradein-applied'
}

export default COOKIES;
